import { render, staticRenderFns } from "./idCard.vue?vue&type=template&id=af5a0bc0&scoped=true&"
import script from "./idCard.vue?vue&type=script&lang=js&"
export * from "./idCard.vue?vue&type=script&lang=js&"
import style0 from "./idCard.vue?vue&type=style&index=0&id=af5a0bc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5a0bc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af5a0bc0')) {
      api.createRecord('af5a0bc0', component.options)
    } else {
      api.reload('af5a0bc0', component.options)
    }
    module.hot.accept("./idCard.vue?vue&type=template&id=af5a0bc0&scoped=true&", function () {
      api.rerender('af5a0bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/myInformation/idCard.vue"
export default component.exports